import {AbstractModel} from './abstract-model';

export class BotPrompt extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  prompt: string | null = null;
  updatedAt: Date | null = null;
  createdAt: Date | null = null;

  override toString(): string {
    return this.name ?? '';
  }
}
